import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectKidsAllowed = createSelector(selectJsonQuery, jsonQuery => getTermValue('kids')(jsonQuery));
